import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { NavLink, LanguageSwitcher } from '../../molecules';
import { useLanguage } from '../../../context/LanguageContext';
import { getCalendarHomeVariant } from '../../../utils/calendarHomeVariant';
import './Header.css';

const navKeys = [
  { href: '/abogados', key: 'nav.home' },
  { href: '/abogados#services', key: 'nav.services' },
  { href: '/abogados#about', key: 'nav.about' },
  { href: '/abogados#contact', key: 'nav.contact' },
];

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [navGolden, setNavGolden] = useState(false);
  const { t } = useLanguage();
  const location = useLocation();
  const calendarOnRoot = location.pathname === '/' ? getCalendarHomeVariant() : null;
  const isLeyPage = location.pathname === '/ley' || calendarOnRoot === 'ley';
  const isFalconPage = location.pathname === '/falcon' || calendarOnRoot === 'falcon';
  const isAbogadosPage = location.pathname === '/abogados';
  const isHome = (location.pathname === '/' && calendarOnRoot === 'home') || isAbogadosPage;

  useEffect(() => {
    if (!isHome) {
      setNavGolden(false);
      return;
    }
    const el = document.getElementById('trusted-by');
    if (!el) return;

    const check = () => {
      const rect = el.getBoundingClientRect();
      setNavGolden(rect.top <= 0);
    };

    check();
    window.addEventListener('scroll', check, { passive: true });
    return () => window.removeEventListener('scroll', check);
  }, [isHome]);

  return (
    <header className={`header ${isLeyPage ? 'header--ley' : ''} ${isFalconPage ? 'header--falcon' : ''} ${navGolden ? 'header--golden' : ''}`}>
      <div className="header__inner">
        {!isLeyPage && (
          <Link to="/abogados" className="header__brand">
            <img src="/img/pfalconlogo.png" alt="Falcon Abogados" className="header__logo" />
          </Link>
        )}
        <div className="header__right">
          <LanguageSwitcher />
          {!isLeyPage && !isFalconPage && (
            <>
              <button
                type="button"
                className="header__toggle"
                aria-expanded={menuOpen}
                aria-label="Toggle menu"
                onClick={() => setMenuOpen(!menuOpen)}
              >
                <span className="header__toggle-bar" />
                <span className="header__toggle-bar" />
                <span className="header__toggle-bar" />
              </button>
              <nav className={`header__nav ${menuOpen ? 'header__nav--open' : ''}`}>
                {navKeys.map((item) => (
                  <NavLink key={item.href} href={item.href} onClick={() => setMenuOpen(false)}>
                    {t(item.key)}
                  </NavLink>
                ))}
              </nav>
            </>
          )}
        </div>
      </div>
    </header>
  );
}

export default Header;
